// export const VOLUME = 'volume';  // Not Implemented
// export const ANSWERS = 'answers';  // Not Implemented
// export const LOCATION = 'location';  // Not Implemented
export const LANGUAGE = 'language';
export const PLAY_STATE = 'playState';
export const FULLSCREEN = 'fullscreen';
export const DEVICE_TYPE = 'deviceType'; 
export const ORIENTATION = 'orientation';
export const VIEWPORT_WIDTH = 'viewportWidth';
export const VIEWPORT_HEIGHT = 'viewportHeight';
export const VARIABLES = 'variables';
export const FORM_DATA = 'formData';
export const SCORE = 'score';
export const PLAYER = 'player';
export const USER_AGENT = 'userAgent';
export const QUIZ = 'quiz';
export const ANNOTATION = 'annotation';
export const LEVEL = 'level';
